import { useGetLanguages } from 'api/useTranslationsApi';
import { useTableQueryState } from 'components/Table/useTableQueryState';
import { Page } from 'layouts/Admin/Page';
import { LanguagesTable } from './components/LanguagesTable';

export const LanguagesView = () => {
  const { state } = useTableQueryState();
  const { data, isFetching } = useGetLanguages();

  return (
    <Page
      title="Sprog"
      breadcrumbs={[
        { name: 'Administration' },
        { name: 'Konfiguration' },
        { name: 'Sprog' },
      ]}
    >
      <div className="py-4">
        <LanguagesTable
          data={data ?? []}
          isFetching={isFetching}
          queryState={state}
        />
      </div>
    </Page>
  );
};
